import { UserAuditLogEntry } from 'apis/auditLogs';

import { LineItems } from './lineItems';
import { SummaryItems } from './summaryItems';
import { UserActivityCard } from './userActivityCard';
import { formatMoney, statusColors } from './userActivityTypes.utils';

type RefundCreatedProps = {
  entry: UserAuditLogEntry<'COMMERCE_REFUND_CREATED'>;
};

export const RefundCreated = ({ entry }: RefundCreatedProps): JSX.Element => (
  <UserActivityCard
    entry={entry}
    icon="exchange"
    color={statusColors.warning}
    title="Refund created"
    summary={
      <SummaryItems
        items={[
          { key: 'order', content: entry.order_id, copyText: entry.order_id },
          {
            key: 'refund',
            content: entry.refund_id,
            copyText: entry.refund_id,
          },
          { key: 'total', content: formatMoney(entry.total) },
        ]}
      />
    }
  >
    {entry.line_items?.length ? <LineItems items={entry.line_items} /> : null}
  </UserActivityCard>
);
